/**
 * @generated SignedSource<<b1a850812ac572cb0b172b8ea6bc32ff>>
 * @relayHash 0446928955970b59719768048eafdff2
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ferrum/570.0.0-2026-07-24T17:42:10.186Z/sourceAttributionMutation

import { ConcreteRequest } from 'relay-runtime';
export type SourceAttributionInput = {
  clientMutationId?: string | null;
  emailToken?: string | null;
  guestUserId?: string | null;
  landingPage?: string | null;
  pageVisits?: ReadonlyArray<pageVisits | null> | null;
  type: string;
  userId: string;
  userToken?: string | null;
  visitCount?: number | null;
};
export type pageVisits = {
  date?: string | null;
  type?: string | null;
  utmParams?: utmParams | null;
};
export type utmParams = {
  landingPage?: string | null;
  visitCount?: number | null;
};
export type sourceAttributionMutation$variables = {
  input: SourceAttributionInput;
};
export type sourceAttributionMutation$data = {
  readonly sourceAttribution: {
    readonly message: string | null;
  } | null;
};
export type sourceAttributionMutation = {
  response: sourceAttributionMutation$data;
  variables: sourceAttributionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SourceAttributionPayload",
    "kind": "LinkedField",
    "name": "sourceAttribution",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "message",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "sourceAttributionMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "sourceAttributionMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "ferrum/570.0.0-2026-07-24T17:42:10.186Z/sourceAttributionMutation",
    "metadata": {},
    "name": "sourceAttributionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "0776fc099f129d46b7995c62aa8613ee";

export default node;
